import React, { Component } from "react";
import { Spin, message } from "antd";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Bridge from "./utils/Bridge";
import moment from "moment";
import { RESEARCH_TYPE } from "./utils/consts";
import { translateApiMessage } from "./utils/functions";
import LEStudyCreateAccount from "./screens/leStudy/components/CreateAccount";

class CreateNewAccount extends Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      phone_no: "",
      consent_status: "",
      relation_to_als: "",
      referred_by: "",
      language_preference: "",
      language: "",

      password: "",
      retype_password: "",
      loading: false,
      type1: "password",
      type2: "password",
    };
  }
  // login
  signupUser = (neurostamp_id) => {
    if (
      RESEARCH_TYPE != "modality.ai" &&
      RESEARCH_TYPE != "ECAS Study" &&
      RESEARCH_TYPE != "LE Study"
    ) {
      message.warning("You are not authorized to create new account.");
      return;
    }

    let params = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      phone_no: this.state.phone_no,
      consent_status: "New",
      relation_to_als: this.state.relation_to_als,
      referred_by: this.state.referred_by,
      language_preference: this.state.language_preference,
      language: this.state.language,
      date_joined: moment().format("MM/DD/YYYY"),
      neurostamp_id: neurostamp_id,
      password: this.state.password,
    };
    if (RESEARCH_TYPE == "modality.ai") {
      this.setState({ loading: true });
      Bridge.participants.speech
        .save_participant(params)
        .then((response) => {
          if (response.status == 1) {
            const language = this.state.language || "English";
            message.success(translateApiMessage(response.message, language));
            this.setState({ loading: false });
            setTimeout(() => {
              window.location.assign("/");
            }, 2000);
          } else {
            const language = this.state.language || "English";
            message.warning(translateApiMessage(response.message, language));
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "ECAS Study") {
      this.setState({ loading: true });
      Bridge.participants.ecas_study
        .save_participant(params)
        .then((response) => {
          if (response.status == 1) {
            const language = this.state.language || "English";
            message.success(translateApiMessage(response.message, language));
            this.setState({ loading: false });
            setTimeout(() => {
              window.location.assign("/");
            }, 2000);
          } else {
            const language = this.state.language || "English";
            message.warning(translateApiMessage(response.message, language));
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "LE Study") {
      this.setState({ loading: true });
      Bridge.participants.le_study
        .save_participant(params)
        .then((response) => {
          if (response.status == 1) {
            const language = this.state.language || "English";
            message.success(translateApiMessage(response.message, language));
            this.setState({ loading: false });
            setTimeout(() => {
              window.location.assign("/");
            }, 2000);
          } else {
            const language = this.state.language || "English";
            message.warning(translateApiMessage(response.message, language));
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      message.warning("You are not authorized to create new account.");
      this.setState({ loading: false });
    }
  };
  generate_neurostamp_id = () => {
    if (!this.state.first_name) {
      message.warning("First name is required.");
      return;
    } else if (!this.state.last_name) {
      message.warning("Last name is required.");
      return;
    } else if (!this.state.email) {
      message.warning("Email is required.");
      return;
    }

    if (RESEARCH_TYPE === "LE Study" && !this.state.relation_to_als) {
      message.warning("Relation to ALS is required.");
      return;
    }
    if (RESEARCH_TYPE === "LE Study" && !this.state.language_preference) {
      message.warning("Language preference is required.");
      return;
    }

    if (
      RESEARCH_TYPE === "LE Study" &&
      this.state.language_preference ===
        "I am comfortable with speech tasks in both languages"
    ) {
      if (!this.state.language) {
        message.warning("Please select language");
        return;
      }
    }

    let password = this.state.password;
    let retype_password = this.state.retype_password;
    if (!password || !retype_password) {
      message.warning("Password is required");
      return;
    }
    if (password !== retype_password) {
      message.warning("Password and retype password do not match");
      return;
    }
    let lowerCaseLetters = /[a-z]/g;
    let upperCaseLetters = /[A-Z]/g;
    let numbers = /[0-9]/g;
    let specialCharacters = /[!@#\$%\^&\*]/g;
    if (!password.match(lowerCaseLetters)) {
      message.warning("Password should contain at least one lowercase letter");
      return;
    }
    if (!password.match(upperCaseLetters)) {
      message.warning("Password should contain at least one uppercase letter");
      return;
    }
    if (!password.match(numbers)) {
      message.warning("Password should contain at least one number");
      return;
    }
    if (!password.match(specialCharacters)) {
      message.warning("Password should contain at least one special character");
      return;
    }
    if (password.length < 8) {
      message.warning("Password should be at least 8 characters long");
      return;
    }

    let params = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      middle_name: "NOTAPPLICABLE",
      email: this.state.email,
      year_of_birth: "",
      day_of_birth: "",
      sex_at_birth: "",
      month_of_birth: "",
      country_of_birth: "",
      city_of_birth: "",
    };
    this.setState({ loading: true });
    Bridge.participants.speech
      .generate_neurostamp_id(params)
      .then((result) => {
        if (result.status == 1) {
          this.signupUser(result.data);
        } else {
          message.warning("Neurostamp id is not generated. Please try again.");
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        if (error) {
          setTimeout(() => {
            message.warning(
              "Neurostamp id is not generated. Please try again."
            );
            this.setState({ loading: false });
          }, 30000);
        } else {
          this.setState({ loading: false });
        }
      });
  };
  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (num) => {
    if (num == "1") {
      this.setState({
        type1: this.state.type1 == "password" ? "text" : "password",
      });
    } else if (num == "2") {
      this.setState({
        type2: this.state.type2 == "password" ? "text" : "password",
      });
    }
  };
  render() {
    return (
      <>
        {RESEARCH_TYPE != "LE Study" && <Header />}
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {RESEARCH_TYPE == "LE Study" ? (
                <LEStudyCreateAccount />
              ) : (
                <div className="authenitication-form">
                  <div className="dark-side d-none d-sm-none d-md-none d-lg-block d-xl-block">
                    <img src={"./assets/images/dark-logo.jpg"} />
                    <p
                      className="inner-text"
                      style={{ fontSize: 18, fontWeight: "500" }}
                    >
                      Our mission is to support efforts to care for ALS patients
                      and work to find treatments. We believe the technology
                      will be a key enabler for the innovation to end ALS, we
                      are here to bridge the gap between patients, research and
                      technology.
                    </p>
                  </div>
                  <div className="right-sides-form">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <h2>Sign up new account</h2>
                          <div className="">
                            <Spin spinning={this.state.loading}>
                              <div className="form-wrapper">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="form-field">
                                      <label>
                                        <box-icon
                                          type="solid"
                                          name="user"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                        ></box-icon>{" "}
                                        First name:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="first_name"
                                        value={this.state.first_name}
                                        onChange={(e) =>
                                          this.setState({
                                            first_name: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-field">
                                      <label>
                                        <box-icon
                                          type="solid"
                                          name="user"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                        ></box-icon>{" "}
                                        Last name:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="last_name"
                                        value={this.state.last_name}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-field">
                                      <label>
                                        <box-icon
                                          type="solid"
                                          name="envelope"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                        ></box-icon>{" "}
                                        Type your e-mail address:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        style={{ marginBottom: 3 }}
                                      />
                                      <p
                                        style={{
                                          fontSize: 14,
                                          color: "#868e96",
                                        }}
                                      >
                                        We are asking for your email address so
                                        that we can send you a link with a
                                        secure login code. This is to protect
                                        your privacy and security.
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-field mt-2">
                                      <label>
                                        <box-icon
                                          type="solid"
                                          name="phone"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                        ></box-icon>{" "}
                                        Type your phone no:
                                      </label>
                                      <input
                                        type="text"
                                        name="phone_no"
                                        value={this.state.phone_no}
                                        onChange={this.handleChange}
                                        style={{ marginBottom: 3 }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-field mt-3">
                                      <label>
                                        <box-icon
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                          name="lock-alt"
                                          type="solid"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                        ></box-icon>
                                        Type your password:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type={this.state.type1}
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                      />
                                      <div
                                        className="togglePassword"
                                        onClick={() => this.togglePassword(1)}
                                      >
                                        {this.state.type1 == "password" ? (
                                          <div className="show-password-icon">
                                            <box-icon
                                              name="show"
                                              color="#ffa3a3"
                                            ></box-icon>
                                          </div>
                                        ) : (
                                          <div className="show-password-icon">
                                            <box-icon
                                              name="low-vision"
                                              color="#ffa3a3"
                                            ></box-icon>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-field">
                                      <label>
                                        <box-icon
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                          name="lock-alt"
                                          type="solid"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                        ></box-icon>
                                        Please retype your password:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type={this.state.type2}
                                        name="retype_password"
                                        value={this.state.retype_password}
                                        onChange={this.handleChange}
                                      />
                                      <div
                                        className="togglePassword"
                                        onClick={() => this.togglePassword(2)}
                                      >
                                        {this.state.type2 == "password" ? (
                                          <div className="show-password-icon">
                                            <box-icon
                                              name="show"
                                              color="#ffa3a3"
                                            ></box-icon>
                                          </div>
                                        ) : (
                                          <div className="show-password-icon">
                                            <box-icon
                                              name="low-vision"
                                              color="#ffa3a3"
                                            ></box-icon>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="password-conditions">
                                    <p>
                                      Your password must meet the following
                                      criteria:
                                    </p>
                                    <ul>
                                      <li>At least 8 characters long</li>
                                      <li>At least one lowercase letter</li>
                                      <li>At least one uppercase letter</li>
                                      <li>At least one number</li>
                                      <li>
                                        At least one special character (such as
                                        ~!@#$%)
                                      </li>
                                    </ul>
                                    <p>
                                      If your chosen password is identified as
                                      being compromised in any previous data
                                      breach, it will be rejected. The best
                                      place to store your password is in your
                                      head. If you must record your password,
                                      store it in a very secure place.
                                    </p>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-field mt-4">
                                      <label>
                                        <box-icon
                                          style={{
                                            marginTop:
                                              window.innerWidth > 600 ? 0 : -3,
                                            marginRight:
                                              window.innerWidth > 600 ? 12 : 9,
                                          }}
                                          name="purchase-tag"
                                          type="solid"
                                          color="#9e9e9e"
                                          size={
                                            window.innerWidth > 600
                                              ? "23px"
                                              : "23px"
                                          }
                                        ></box-icon>
                                        Relation to ALS:{" "}
                                        {RESEARCH_TYPE === "LE Study" && (
                                          <span className="text-danger">*</span>
                                        )}
                                      </label>
                                      <select
                                        name="relation_to_als"
                                        value={this.state.relation_to_als}
                                        onChange={this.handleChange}
                                        className="form-control mt-2 create-select-option"
                                      >
                                        <option value="">
                                          Select Relation To ALS
                                        </option>
                                        {RESEARCH_TYPE === "LE Study" ? (
                                          <>
                                            <option value="Living with ALS">
                                              Living with ALS
                                            </option>
                                            <option value="Healthy control">
                                              Healthy control
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value="Living with ALS">
                                              Living with ALS
                                            </option>
                                            <option value="Asymptomatic Gene Carrier">
                                              Asymptomatic Gene Carrier
                                            </option>
                                            <option value="Caregiver">
                                              Caregiver
                                            </option>
                                            <option value="Family Member">
                                              Family Member
                                            </option>
                                            <option value="Friend">
                                              Friend
                                            </option>
                                            <option value="Healthcare professional">
                                              Healthcare professional
                                            </option>
                                            <option value="Other">Other</option>
                                          </>
                                        )}
                                      </select>
                                    </div>
                                  </div>

                                  {RESEARCH_TYPE === "LE Study" && (
                                    <div className="col-lg-12">
                                      <div className="form-field mt-4">
                                        <label className="align-items-start">
                                          <box-icon
                                            style={{
                                              marginTop:
                                                window.innerWidth > 600
                                                  ? 0
                                                  : -3,
                                              marginRight:
                                                window.innerWidth > 600
                                                  ? 12
                                                  : 9,
                                            }}
                                            name="globe"
                                            type="solid"
                                            color="#9e9e9e"
                                            size={
                                              window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                          ></box-icon>
                                          Please complete the speech tasks in
                                          English and Spanish (3 sentences for
                                          each), if possible. Choose your
                                          preference:{" "}
                                          {RESEARCH_TYPE === "LE Study" && (
                                            <span className="text-danger">
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <select
                                          name="language_preference"
                                          value={this.state.language_preference}
                                          onChange={(e) => {
                                            this.setState({
                                              language_preference:
                                                e.target.value,
                                              language: "",
                                            });
                                          }}
                                          className="form-control mt-2 create-select-option"
                                        >
                                          <option value="">Select</option>
                                          <option value="I am comfortable with speech tasks in both languages">
                                            I am comfortable with speech tasks
                                            in both languages
                                          </option>
                                          <option value="I’d like to do speech tasks in Spanish only; I am not confident in English">
                                            I’d like to do speech tasks in
                                            Spanish only; I am not confident in
                                            English
                                          </option>
                                        </select>
                                      </div>
                                      {this.state.language_preference ===
                                        "I am comfortable with speech tasks in both languages" && (
                                        <div className="form-field mt-4">
                                          <label>
                                            <box-icon
                                              style={{
                                                marginTop:
                                                  window.innerWidth > 600
                                                    ? 0
                                                    : -3,
                                                marginRight:
                                                  window.innerWidth > 600
                                                    ? 12
                                                    : 9,
                                              }}
                                              name="globe"
                                              type="solid"
                                              color="#9e9e9e"
                                              size={
                                                window.innerWidth > 600
                                                  ? "23px"
                                                  : "23px"
                                              }
                                            ></box-icon>
                                            Which language(s) do you want to use
                                            for your speech session?{" "}
                                            {RESEARCH_TYPE === "LE Study" && (
                                              <span className="text-danger">
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <select
                                            name="language"
                                            value={this.state.language}
                                            onChange={(e) =>
                                              this.setState({
                                                language: e.target.value,
                                              })
                                            }
                                            className="form-control mt-2 create-select-option"
                                          >
                                            <option value="">
                                              Select Language
                                            </option>
                                            <option value="English">
                                              English
                                            </option>
                                            <option value="Spanish">
                                              Spanish
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>

                                <br />

                                <center>
                                  <button
                                    type="button"
                                    className="create-new-account-button"
                                    onClick={() =>
                                      this.generate_neurostamp_id()
                                    }
                                  >
                                    <box-icon
                                      type="solid"
                                      name="user-plus"
                                      color="#fff"
                                      size={"25px"}
                                    ></box-icon>
                                    &nbsp; <span>CREATE NEW ACCOUNT</span>
                                  </button>
                                </center>
                                <span
                                  className="extra-link-with-text"
                                  style={{ top: 30 }}
                                >
                                  Already have an account? &nbsp;
                                  <a href="/">Sign In</a>
                                </span>
                              </div>
                            </Spin>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {RESEARCH_TYPE != "LE Study" && <Footer />}
      </>
    );
  }
}
export default CreateNewAccount;
